import { nanoid } from "nanoid";
import { useMemo } from "react";
import slugify from "slugify";

type UseInputIdProps = {
  id?: string | undefined;
  name?: string | undefined;
};

export function useStableId(props: UseInputIdProps): string {
  return useMemo(
    () =>
      props.id ||
      (typeof props.name === "string" ? `${slugify(props?.name)}-${nanoid()}` : `${nanoid()}`),
    [props.id, props.name],
  );
}

export default useStableId;
